/**
 * Pone en mayúscula la primera letra de cada palabra en una cadena, con excepciones.
 *
 * @param str - La cadena a capitalizar.
 *
 * @returns La cadena capitalizada.
 */
export function capitalize(str: string): string {
  const exceptions = ['de'];
  return str
    .split(' ')
    .map((word) => {
      if (exceptions.includes(word.toLowerCase())) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

export function capitalizeFirst(str: string): string {
  if (!str) return '';
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export const formatSearchTerm = (term: string): string => {
  if (!term) return '';

  return term.replace(/\s+/g, '').replace(/\.$/, '');
};

export const processPurchaseOrderValue = (value: string): string => {
  let result = value;

  while (result.includes(' .') || result.includes('. ')) {
    result = result.replace(/ \.+/g, ' ').replace(/\. +/g, ' ');
  }

  return result.replace(/\.$/g, '');
};
